import { createClient } from 'react-fetching-library';

export const Client = createClient();